import api from './index'

export function getB2bCompanyCategories(params) {
  return api.get('/api/v1/b2b/company-categories', { params })
}

export function createB2bCompanyCategory(data) {
  return api.post('/api/v1/b2b/company-categories', data)
}

export function updateB2bCompanyCategory(categoryCode, data) {
  return api.put(`/api/v1/b2b/company-categories/${categoryCode}`, data)
}

export function getB2bCompanies(params) {
  return api.get('/api/v1/b2b/companies', { params })
}

export function getB2bCompany(companyCode) {
  return api.get(`/api/v1/b2b/companies/${companyCode}`)
}

export function createB2bCompany(data) {
  return api.post('/api/v1/b2b/companies', data)
}

export function updateB2bCompany(companyCode, data) {
  return api.put(`/api/v1/b2b/companies/${companyCode}`, data)
}

export function getB2bCompanyProducts(companyCode, params) {
  return api.get(`/api/v1/b2b/companies/${companyCode}/products`, { params })
}

export function createB2bCompanyProduct(companyCode, data) {
  return api.post(`/api/v1/b2b/companies/${companyCode}/products`, data)
}

export function updateB2bCompanyProduct(companyProductCode, data) {
  return api.put(`/api/v1/b2b/company-products/${companyProductCode}`, data)
}

export function deleteB2bCompanyProduct(companyProductCode) {
  return api.delete(`/api/v1/b2b/company-products/${companyProductCode}`)
}

export function getB2bEvidenceRequests(params) {
  return api.get('/api/v1/b2b/evidence-requests', { params })
}

export function updateB2bEvidenceStatus(evidenceRequestCode, data) {
  return api.patch(`/api/v1/b2b/evidence-requests/${evidenceRequestCode}/status`, data)
}
